import { ProviderMeta } from '@shared/providers/provider-meta';
import { DataField } from '@shared/providers/types';

const salesforceIdRegexp = /^([a-z0-9]{15,18})$/i;

class SalesforceMeta implements ProviderMeta {
  getIdFieldName(): string {
    return 'Id';
  }

  getIdFieldlabel(): string {
    return 'Id';
  }

  isIdValue(value: string): boolean {
    return salesforceIdRegexp.test(value);
  }

  getIdFieldLength(): number {
    return 18;
  }

  getDataFieldFromHeader(header: string): DataField {
    return { name: header, label: header, type: 'string', originalField: {} } as DataField;
  }
}

export default SalesforceMeta;
